<template>
  <transition name="scale" >
    <vue-draggable-resizable :key="data.key"
                   v-if="!data.minimized"
                   dragHandle=".drag-handler"
                   :class="`data-card-wrapper data-card-${cardSizeClass}`"
                   :minWidth="320"
                   :minHeight="200"
                   :active="data.isActive"
                   :w="width"
                   :h="height"
                   :x="left"
                   :y="top"
                   :z="999"
                   parent
                   @resizing="resize" @dragging="dragHandle">
      <div>
        <v-container fluid class="data-card-header">
          <v-row align="center" justify="space-around" class="drag-handler">
            <v-col cols="7" class="data-card-title">
              <v-icon dark class="mr-2">{{getCardIcon(data.type)}}</v-icon>
              <v-tooltip top open-delay="3000">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <slot name="title">Card Title</slot>
                  </span>
                </template>
                <span><slot name="title">Card Title</slot></span>
              </v-tooltip>
            </v-col>
            <v-col class="text-right py-0" cols="5">
              <slot name="share-link" />
              <v-btn icon color="white" title="Minimize" @click="minimize(data.key)"><v-icon>mdi-window-minimize</v-icon></v-btn>
              <v-btn icon color="white" title="Maximize" @click="switchMaximize()"><v-icon>mdi-window-maximize</v-icon></v-btn>
              <v-btn icon color="white" title="Close" @click="remove(data)"><v-icon>mdi-window-close</v-icon></v-btn>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <div class="data-card-body">
        <v-container fluid class="pa-0">
          <slot>top: {{top}} <br> left: {{left}}</slot>
        </v-container>
      </div>
    </vue-draggable-resizable>
  </transition>
</template>

<script>
import VueDraggableResizable from 'vue-draggable-resizable';
import store from "@/store";
import { mapGetters } from 'vuex'

export default {
  name: "DataCard",
  props: ['data'],
  components: {
    VueDraggableResizable
  },
  data() {
    return {
      isClosed: false,
      active: true,
      width: 600,
      height: 400,
      top: 100,
      left: 100,
      cardSizeClass: 'md',
      saved: {
        width: 0,
        height: 0,
        top: 100,
        left: 100
      }
    }
  },
  mounted() {
    this.updateSizeClass();
  },
  computed: {
    ...mapGetters(
        'cards', ['getCards']
    ),
  },
  methods: {
    minimize(key) {
      store.dispatch('cards/MINIMIZE', key)
    },
    remove(data) {
      if (data.type === 'chat'){
        const chatMessagesCards = this.getCards.filter(item=>item.type === 'chatMessages')
        chatMessagesCards.forEach(item=>{
          store.dispatch('cards/REMOVE', item.key)
        })
      }

      store.dispatch('cards/REMOVE', data.key)
    },
    dragHandle(x, y) {
      this.left = x;
      this.top = y;
    },
    resize(x, y, width, height) {
      this.left = x;
      this.top = y;
      this.width = width;
      this.height = height;
      this.updateSizeClass();
      return false;
    },
    updateSizeClass() {
      const sizeWidthMap = {
        'xs': {min: 0, max: 599},
        'sm': {min: 600, max: 959},
        'md': {min: 960, max: 1264},
        'lg': {min: 1275, max: 1904},
        'xl': {min: 1904, max: 1000000},
      }
      for (let size in sizeWidthMap) {
        const bp = sizeWidthMap[size];
        if (this.width >= bp.min && this.width <= bp.max) {
          this.cardSizeClass = size;
          break;
        }
      }
    },
    getCardIcon(type) {
      const typeIconsMap = {
        offer: 'fa-hand-holding-usd',
        campaign: 'fal fa-bullhorn',
        program: 'fal fa-upload',
        advertiser: 'fal fa-ad',
        affiliate: 'fal fa-user-friends',
        chat: 'fal fa-comment-dots',
        chatMessages: 'fal fa-comments',
      }

      return typeIconsMap[type] || '';
    },
    async switchMaximize() {
      if(!this.saved.width || !this.saved.height) {
        this.saved = Object.assign({}, {
          width: this.width,
          height: this.height,
          top: this.top,
          left: this.left
        });
        this.resize(0,0, window.innerWidth, window.innerHeight);
        // this.dragHandle(0, 0)
      } else {
        this.resize(this.saved.left, this.saved.top, this.saved.width, this.saved.height);
        await this.moveLeft(this.saved.left);
        await this.moveTop(this.saved.top);
        this.saved = {
          width: 0,
          height: 0,
          top: 0,
          left: 0
        }
        // this.$forceUpdate();
      }
    },
    moveLeft(left) {
      this.left = 0;
      return Promise.resolve(setTimeout(() => {
        this.left = left;
      }, 1))
    },
    moveTop(top) {
      this.top = 0;
      return Promise.resolve(setTimeout(() => {
        this.top = top;
      }, 1))
    },
  },
  watch: {
    'data.minimized'() {
      if (!this.data.minimized) {
        this.data.active = true;
      }
    },
    'data.customSize': {
      deep: true,
      handler: function(newVal) {
        if (this.data.type === 'chat' || this.data.type === 'chatMessages' || this.data.type === 'lid') {
          this.width = newVal.width;
          this.height = newVal.height;
          this.top = newVal.top;
          this.left = newVal.left;
        } else {
          this.width = Math.floor(window.innerWidth * 0.7)
          this.height= Math.floor(window.innerHeight * 0.8)
        }
      },
      immediate: true
    }

    // 'data.key': {
    //   handler: function(newKey, oldKey) {
    //
    //   },
    //   immediate: true
    // }
  }
}
</script>

<style lang="sass">
  .data-card-wrapper.vdr.active
    z-index: 1000 !important
    .data-card-header
      background-color: var(--v-primary-base)
  .data-card-wrapper.vdr
    transition: tranform 0.5s
    background-color: #FFFFFF
    border: 1px solid var(--v-primary-base)
    border-radius: 3px
    box-shadow: 3px 3px 15px 0px rgba(0,0,0,0.4)

    .data-card-body
      height: calc(100% - 45px)
      overflow: auto
    .data-card-header
      font-weight: 600
      color: #fff
      background-color: var(--v-primary-lighten1)
      .data-card-title
        white-space: nowrap
        text-overflow: ellipsis
        overflow: hidden
    .handle
      border: none
      box-shadow: none
      background: transparent
      z-index: 1
    .handle-bm, .handle-tm
      width: 100%
      height: 10px
      left: 0
      margin-left: 0
      margin-right: 5px
      cursor: ns-resize
    .handle-ml, .handle-mr
      height: 100%
      margin-top: 0
      margin-bottom: 5px
      top: 0
      cursor: ew-resize
    .handle-tm
      top: -5px
    .handle-tr
      top: -5px
      right: -5px
      cursor: nesw-resize
      z-index: 2
    .handle-mr
      right: -5px
    .handle-br
      bottom: -5px
      right: -5px
      cursor: nwse-resize
      z-index: 2
    .handle-bm
      bottom: -5px
      cursor: ns-resize
    .handle-bl
      bottom: -5px
      left: -5px
      cursor: nesw-resize
      z-index: 2
    .handle-ml
      left: -5px
    .handle-tl
      top: -5px
      left: -5px
      cursor: nwse-resize
      z-index: 2

  .vdr.active:before
    outline: none

  .slide-enter-active
    animation: slide-in-top 0.6s linear

  .slide-leave-active
    animation: slide-in-top 0.6s linear reverse

  .tilt-in-enter-active
    position: absolute
    animation: tilt-in-top-1 0.4s cubic-bezier(0.600, -0.280, 0.735, 0.045) both

  .tilt-in-leave-active
    position: absolute
    animation: tilt-in-top-1 0.4s cubic-bezier(0.600, -0.280, 0.735, 0.045) both reverse

  //
  //.scale-enter-active, .scale-leave-active
  //  opacity: 1
  //  transition: all 0.8s cubic-bezier(0.250, 0.460, 0.450, 0.940)
  //
  //.scale-enter-from, .scale-leave-to
  //  opacity: 0

  .scale-enter-active
    transition: tranform 0.5s
    animation: scale-in-center 0.3s cubic-bezier(0.250, 0.460, 0.450, 0.940)

  .scale-leave-active
    transition: tranform 0.5s
    animation: scale-in-center 0.3s cubic-bezier(0.250, 0.460, 0.450, 0.940) reverse

  @keyframes tilt-in-top-1
    0%
      transform: rotateY(30deg) translateY(-300px) skewY(-30deg)
      opacity: 0
    100%
      opacity: 1

  @keyframes slide-in-top
    0%
      transform: translateY(-1000px)
      opacity: 0
    100%
      transform: translateY(0)
      opacity: 1


  @keyframes slide-in-blurred-top
    0%
      transform: perspective(200px) rotateX(20deg)
      margin-top: -800px
      opacity: 0
    100%
      transform: perspective(0px) rotateX(0deg)
      margin-top: initial
      opacity: 1

  @keyframes scale-in-center
    0%
      transform: scale(0) translateX(100px) translateY(100px)
      transform-origin: 55% 0%
      filter: blur(20px)
      opacity: 1
    100%
      transform: scale(1) translateX(100px) translateY(100px)
      transform-origin: 55% 50%
      filter: blur(0)
      opacity: 1

</style>
